<template>
    <b-container fluid>
        <b-list-group>
            <b-list-group-item
                v-for="(teamMember, i) in team"
                :key="teamMember.id"
            >
                <b-row>
                    <b-col cols="5"
                        ><label
                            >{{ i + 1 }} - {{ teamMember.user.name }}</label
                        ></b-col
                    >
                    <!-- panel de botones administrativo -->
                    <b-col
                        cols="7"
                        v-if="isAdministrative && evaluationsLoaded"
                    >
                        <b-row>
                            <b-col cols="5" v-if="validatePeople(teamMember)">
                                <b-btn
                                    size="sm"
                                    block
                                    variant="success"
                                    disabled
                                    >Evaluado <i class="fa fa-check"></i
                                ></b-btn>
                            </b-col>
                            <b-col cols="5" v-else>
                                <b-btn
                                    size="sm"
                                    block
                                    variant="primary"
                                    @click="evaluateSubordinate(teamMember)"
                                    >Evaluar</b-btn
                                >
                            </b-col>
                            <b-col
                                cols="6"
                                v-if="validateQualification(teamMember)"
                            >
                                <b-btn
                                    size="sm"
                                    block
                                    variant="success"
                                    disabled
                                    >Compromiso evaluado
                                    <i class="fa fa-check"></i
                                ></b-btn>
                            </b-col>
                            <b-col cols="6" v-else>
                                <b-btn
                                    size="sm"
                                    block
                                    variant="primary"
                                    :disabled="!validateCommitment(teamMember)"
                                    @click="
                                        openQualifyCommitmentForm(teamMember)
                                    "
                                    >Calificar Compromiso</b-btn
                                >
                            </b-col>
                        </b-row>
                    </b-col>
                    <!-- panel de botones operativos -->
                    <b-col cols="7" v-if="isOperative  && evaluationsLoaded">
                        <b-row class="justify-content-end">
                            <b-col cols="8" v-if="validatePeople(teamMember)">
                                <b-btn
                                    size="sm"
                                    block
                                    variant="success"
                                    disabled
                                    >Evaluado <i class="fa fa-check"></i
                                ></b-btn>
                            </b-col>
                            <b-col cols="8" v-else>
                                <b-btn
                                    size="sm"
                                    block
                                    variant="primary"
                                    @click="evaluateSubordinate(teamMember)"
                                    >Evaluar</b-btn
                                >
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>
    </b-container>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '../../../store/commitTypes'
export default {
    props: {
        evaluation: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        team: [],
        peopleEvaluated: [],
        // evaluation: '',
        storedCommitment: false,
        isAdministrative: false,
        isOperative: false,
        evaluationsLoaded: false,
    }),
    methods: {
        ...mapMutations({
            setCurrentEvaluation: mutations.SET_CURRENT_EVALUATION,
            setCurrentEvaluatedUser: mutations.SET_CURRENT_EVALUATED_USER,
        }),
        async loadTeam() {
            this.isAdministrative = this.evaluation.administrative
                ? true
                : false
            this.isOperative = !this.evaluation.administrative ? true : false
            if (this.evaluationId !== 0) {
                const { data } = await repo.get(
                    `evaluation-users/${this.evaluation.id}/leader-team/${this.user.id}`
                )
                //this.loadEvaluatedPeople()
                this.team = data
            }
        },
        evaluateSubordinate(subordinate) {
            this.setCurrentEvaluation(this.evaluation)
            this.setCurrentEvaluatedUser(subordinate)
            this.$emit('close-popup-team-evaluation-form')
            this.$router.push({
                name: 'evaluationPage',
            })
        },
        async loadEvaluatedPeople() {
            const {
                data,
            } = await repo.get(
                `performance-evaluations/${this.evaluation.id}/load-evaluated-people`,
                { evaluatorId: this.user.id }
            )
            this.peopleEvaluated = data
        },
        validatePeople(teamMember) {
            return !!this.peopleEvaluated.filter(
                (item) => item.evaluated_id === teamMember.user.id
            ).length
        },
        validateCommitment(teamMember) {
            return !!this.peopleEvaluated.filter(
                (item) =>
                    item.evaluated_id === teamMember.user.id &&
                    !!item.commitments
            ).length
        },
        openQualifyCommitmentForm(teamMember) {
            const data = this.peopleEvaluated.filter(
                (item) =>
                    item.evaluated_id === teamMember.user.id &&
                    !!item.commitments
            )
            this.$emit('open-qualify-commitment-form', data)
        },
        validateQualification(teamMember) {
            return !!this.peopleEvaluated.filter(
                (item) =>
                    item.evaluated_id === teamMember.user.id &&
                    !!item.commitment_approval_date
            ).length
        },
        loadTeamAndEvaluatedPeople(){
            this.evaluationsLoaded = false
            this.team = []
            this.peopleEvaluated = []
            this.loadTeam()
            Promise.all([this.loadEvaluatedPeople()]).then(
            () => (this.evaluationsLoaded = true))
        }
    },
    mounted(){
        this.$bus.$on('validate-evaluation-status', this.loadTeamAndEvaluatedPeople)
    },
    created(){
        this.loadTeamAndEvaluatedPeople()
    }
}
</script>
